var parent = require('../../stable/array/is-array');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/array/is-array.js
// module id = 510
// module chunks = 0 1